import { z } from 'zod';

/** POSIX の仮想ルートに固定し、ルートより上の .. は捨てる。 */
export function normalizeVirtualPath(value: string): string {
  if (value.length > 500 || value.includes('\\') || value.includes('\0')) throw new Error('パスが正しくありません');
  const parts: string[] = [];
  for (const part of value.split('/')) {
    if (!part || part === '.') continue;
    if (part === '..') parts.pop();
    else parts.push(part);
  }
  return parts.join('/');
}

export const VirtualPathSchema = z
  .string()
  .max(500)
  .refine((p) => !p.includes('\0') && !p.includes('\\'), 'パスが正しくありません')
  .transform(normalizeVirtualPath);
